"use strict";
window.theme = window.theme || {};
if (!Array.isArray(window.promotionalProgressbar)) {
  window.promotionalProgressbar = [];
}

function promotionalBool(value) {
  return value === true || value === "true" || value === 1 || value === "1";
}

function normalizePromotionalTier(row) {
  if (!row || typeof row !== "object") return null;
  var pid = row.productId;
  if (pid === null || pid === undefined) pid = "";
  else pid = String(pid);
  return Object.assign({}, row, {
    productId: pid,
    variants: Array.isArray(row.variants) ? row.variants : [],
  });
}

function cartItemMatchesProductId(item, promoProductId) {
  if (item == null || promoProductId == null || promoProductId === "") return false;
  return String(item.product_id) === String(promoProductId);
}
theme.PromotionalProgressbar = function () {
  function PromotionalProgressbar() {
    var self = this;
    this.selector = {};
    this.bindSelectors();
    this.state = {
      closestLowerArray: [],
      closestHigherArray: [],
      closestLowerThreshold: 0,
      closestHigherThreshold: 0,
      deletedFreeGift: [],
      giftVariantBlocked: [],
      recentlyCurrency: localStorage.getItem("ebsRecentlyCurrency") || null,
      recentlyFreeGiftProductIds: JSON.parse(localStorage.getItem("ebsRecentlyFreeGiftProductIds") || "[]"),
      isRecalculating: false,
      recalculateTimeout: null,
      processingFreeGifts: [],
      cartUpdateDebounceTimer: null,
      scheduledRecalculateTimer: null,
    };
    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === "cart-items") {
          clearTimeout(self.state.cartUpdateDebounceTimer);
          self.state.cartUpdateDebounceTimer = null;
          self.syncPromotionTierDom();
          if (self.selector.main) {
            if (event.cartData) {
              self.recalculate(event.cartData);
            } else {
              self.scheduleRecalculate(120);
            }
          } else {
            window.theme?.cartDrawerBusy?.end?.(event.cartData);
          }
          return;
        }
        clearTimeout(self.state.cartUpdateDebounceTimer);
        self.state.cartUpdateDebounceTimer = setTimeout(function () {
          self.state.cartUpdateDebounceTimer = null;
          self.load();
        }, 280);
      });
    }
    this.load();
  }
  PromotionalProgressbar.prototype.bindSelectors = function () {
    this.selector.main = document.getElementById("promotional-progress");
    this.selector.bars = document.querySelectorAll(".promotional-progress > .progress > .bars > .bar");
    this.selector.threshold = document.querySelectorAll(
      ".promotional-progress > .progress > .bars-threshold > .threshold.show",
    );
    this.selector.heading = document.getElementById("progress-heading");
    this.selector.formCartDrawer = document.getElementById("CartDrawer-Form");
    this.selector.cartDrawerCheckout = document.getElementById("CartDrawer-Checkout");
  };
  PromotionalProgressbar.prototype.scheduleRecalculate = function (delayMs) {
    var _ = this;
    var ms = typeof delayMs === "number" ? delayMs : 120;
    clearTimeout(_.state.scheduledRecalculateTimer);
    _.state.scheduledRecalculateTimer = setTimeout(function () {
      _.state.scheduledRecalculateTimer = null;
      _.recalculate();
    }, ms);
  };
  PromotionalProgressbar.prototype.syncPromotionTierDom = function () {
    var _ = this;
    _.bindSelectors();
    if (!_.selector.main) return;

    var tierScript = _.selector.main.querySelector('script[type="application/json"][data-promotional-tiers]');
    if (tierScript && tierScript.textContent.trim()) {
      try {
        var parsed = JSON.parse(tierScript.textContent);
        window.promotionalProgressbar = (Array.isArray(parsed) ? parsed : [])
          .map(normalizePromotionalTier)
          .filter(function (row) {
            return row !== null;
          });
      } catch (err) {
        console.warn("PromotionalProgressbar: invalid tier JSON", err);
        window.promotionalProgressbar = [];
      }
    } else if (!Array.isArray(window.promotionalProgressbar)) {
      window.promotionalProgressbar = [];
    }

    if (_.state.recentlyCurrency !== _.selector.main.dataset.cartCurrency) {
      _.state.recentlyFreeGiftProductIds.forEach(async (productId) => {
        await _.checkfreegift([], "remove", productId, "", "", "", "", "");
      });

      localStorage.setItem("ebsRecentlyCurrency", _.selector.main.dataset.cartCurrency);
      localStorage.setItem("ebsRecentlyFreeGiftProductIds", JSON.stringify([]));
    }

    document.querySelectorAll(".promotional-progress .bars-threshold .threshold").forEach(function (el) {
      el.classList.remove("show");
      var bt = el.querySelector(".bar-text");
      if (bt) bt.innerHTML = "";
    });

    window.promotionalProgressbar.sort(function (a, b) {
      return parseFloat(a.threshold) - parseFloat(b.threshold);
    });
    if (window.promotionalProgressbar.length > 0) {
      const maxAmountThreshold = parseFloat(
        window.promotionalProgressbar[window.promotionalProgressbar.length - 1].threshold,
      );
      let prePossition = 0;
      window.promotionalProgressbar.forEach((bar) => {
        const percentageAmountThreshold = parseFloat(bar.threshold) / maxAmountThreshold;
        const currentThresholdPercentage = percentageAmountThreshold * 100;
        const calcPosition = (currentThresholdPercentage / 100) * 8;
        let roundedPosition = Math.round(calcPosition);
        if (prePossition == roundedPosition) {
          roundedPosition = roundedPosition + 1;
        }

        prePossition = roundedPosition;
        const thresholdBarEls = document.querySelectorAll(
          ".promotional-progress > .progress > .bars-threshold > .threshold",
        );
        if (thresholdBarEls.length > 0) {
          Array.from(thresholdBarEls).map((el, index) => {
            if (index + 1 === roundedPosition) {
              const title = bar.thresholdTitle != null ? String(bar.thresholdTitle) : "";
              const bt = el.querySelector(".bar-text");
              if (bt) bt.innerHTML = title;
              el.classList.add("show");
            }
          });
        }
      });
      _.selector.main.classList.add("active");
    } else {
      _.selector.main.classList.remove("active");
      const activeThresholdBars = document.querySelectorAll(
        ".promotional-progress > .progress > .bars-threshold > .threshold.show",
      );
      activeThresholdBars.forEach((threshold) => {
        threshold.classList.remove("active");
      });
    }
  };
  PromotionalProgressbar.prototype.load = async function () {
    var _ = this;
    _.syncPromotionTierDom();
    if (!_.selector.main) return;
    if (window.promotionalProgressbar.length > 0) {
      await _.recalculate();
    }
  };
  PromotionalProgressbar.prototype.formatPrice = function (amount) {
    var _ = this;
    return amount.toFixed(2);
  };
  PromotionalProgressbar.prototype.recalculate = async function (cartDataOrNull) {
    var _ = this;
    _.bindSelectors();
    if (!_.selector.main) return;

    // Clear any pending recalculation
    if (_.state.recalculateTimeout) {
      clearTimeout(_.state.recalculateTimeout);
      _.state.recalculateTimeout = null;
    }

    // If already recalculating, debounce the call
    if (_.state.isRecalculating) {
      _.state.recalculateTimeout = setTimeout(function () {
        _.recalculate(cartDataOrNull);
      }, 100);
      return;
    }

    // Set flag to prevent concurrent recalculations
    _.state.isRecalculating = true;
    if (!window.theme?.cartDrawerBusy?.depth) {
      window.theme?.cartDrawerBusy?.begin?.();
    }

    var lastCartState = cartDataOrNull || null;

    var cartPromise = cartDataOrNull
      ? Promise.resolve(cartDataOrNull)
      : fetch(window.Shopify.routes.root + "cart.js", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }).then(function (response) {
          if (!response.ok) {
            return response.text().then(function (t) {
              throw new Error("cart.js HTTP " + response.status);
            });
          }
          return response.json();
        });

    await cartPromise
      .then(async function (data) {
        lastCartState = data;
        // Calculate both totals: discounted (for gifts & shipping) and original (for discount)
        const cart_total = data.total_price / 100; // (for gifts & shipping)
        const original_cart_total = data.original_total_price / 100; // (for discount)

        // Helper function to get appropriate total based on threshold type
        const getThresholdTotal = function (promo) {
          return promo.thresholdType !== "Discount" ? cart_total : original_cart_total;
        };

        if (window.promotionalProgressbar.length > 0 && (cart_total > 0 || original_cart_total > 0)) {
          const headingEl = _.selector.heading;
          const progressHeadingRoot = headingEl && headingEl.closest(".progress-heading");
          const freeShippingUnlocked = document.getElementById("free-shipping-unlocked");
          const freeGiftLocked = document.getElementById("free-gift-locked");
          const freeGiftUnlockedContainer = document.getElementById("free-gift-unlocked");
          const freeShippingLocked = document.getElementById("free-shipping-locked");
          freeShippingUnlocked && freeShippingUnlocked.classList.remove("active");
          freeGiftLocked && freeGiftLocked.classList.remove("active");
          freeShippingLocked && freeShippingLocked.classList.remove("active");
          if (freeGiftUnlockedContainer) freeGiftUnlockedContainer.innerHTML = "";
          _.state.closestLowerArray = [];
          _.state.closestHigherArray = [];
          _.state.closestHigherThreshold = 0;
          _.state.closestLowerThreshold = 0;

          for (const promo of window.promotionalProgressbar) {
            const thresholdTotal = getThresholdTotal(promo);
            if (parseFloat(promo.threshold) <= thresholdTotal) {
              _.state.closestLowerArray.push(promo);
              _.state.closestLowerThreshold = promo.threshold;
            }
            if (parseFloat(promo.threshold) > thresholdTotal) {
              _.state.closestHigherArray.push(promo);
              _.state.closestHigherThreshold = promo.threshold;
              break;
            }
          }
          if (_.state.closestLowerArray.length > 0) {
            for (const promo of _.state.closestLowerArray) {
              if (freeShippingUnlocked) {
                freeShippingUnlocked.classList.add("active");
                const titleText = String(promo.thresholdTitle || "").replace("</br>", " ");
                const titleStrong = freeShippingUnlocked.querySelector(".details .title strong");
                const titleEl = freeShippingUnlocked.querySelector(".details .title");
                if (titleStrong) {
                  titleStrong.textContent = titleText;
                } else if (titleEl) {
                  titleEl.textContent = titleText;
                }
              }
            }
          }
          if (_.state.closestHigherArray.length > 0) {
            for (const promo of _.state.closestHigherArray) {
              const thresholdTotal = getThresholdTotal(promo);
              const remainingThreshold = parseFloat(promo.threshold) - thresholdTotal;
              const remainingMessage = promo
                ? String(promo.message || "")
                    .replace(
                      "[remaining_amount]",
                      `${_.selector.main.dataset.currentCurrency}${_.formatPrice(remainingThreshold)}`,
                    )
                    .replace("[title]", String(promo.thresholdTitle || "").replaceAll("</br>", " "))
                    .replace("[product_name]", String(promo.productName || ""))
                : "";
              if (progressHeadingRoot) {
                if (promo && promo.message !== "") {
                  progressHeadingRoot.classList.remove("empty-title");
                } else {
                  progressHeadingRoot.classList.add("empty-title");
                }
              }
              if (headingEl) headingEl.innerHTML = promo ? remainingMessage : "";
              freeShippingLocked && freeShippingLocked.classList.add("active");
              if (freeShippingLocked) {
                const lockedNested = freeShippingLocked.querySelector(".details > .title > span");
                const lockedTitle = freeShippingLocked.querySelector(".details > .title");
                const lockedMsgEl = lockedNested || lockedTitle;
                if (lockedMsgEl) lockedMsgEl.innerHTML = remainingMessage;
              }
            }
          }
          const activeThresholdBars = document.querySelectorAll(
            ".promotional-progress > .progress > .bars-threshold > .threshold.show",
          );

          activeThresholdBars.forEach((bar, index) => {
            if (index < parseInt(_.state.closestLowerArray.length)) {
              bar.classList.add("active");
            } else {
              bar.classList.remove("active");
            }
          });

          const thresholds = _.selector.main.querySelectorAll(".threshold");
          const activeThresholds = _.selector.main.querySelectorAll(".threshold.show.active");
          let lastIndex = -1;
          if (activeThresholds.length > 0) {
            const lastActive = activeThresholds[activeThresholds.length - 1];
            lastIndex = Array.from(thresholds).indexOf(lastActive);
          }

          const main = _.selector.main;

          if (main) {
            // Get all .threshold elements inside the main container
            const thresholds = Array.from(main.querySelectorAll(".threshold"));
            // Filter those that are .show
            const showThresholds = thresholds.filter((el) => el.classList.contains("show"));
            // Filter those that are both .show and .active
            const activeShowThresholds = showThresholds.filter((el) => el.classList.contains("active"));

            // Find the index of the next .threshold.show after the last .threshold.show.active
            let nextShowIndex = -1;
            let lastActiveIndex = -1;
            if (activeShowThresholds.length > 0) {
              const lastActive = activeShowThresholds[activeShowThresholds.length - 1];
              lastActiveIndex = thresholds.indexOf(lastActive);
              const lastActiveShowIndex = showThresholds.indexOf(lastActive);
              if (lastActiveShowIndex < showThresholds.length - 1) {
                // Next .show after last .show.active
                nextShowIndex = thresholds.indexOf(showThresholds[lastActiveShowIndex + 1]);
              }
            } else if (showThresholds.length > 0) {
              // If no active, the first .show is the next
              nextShowIndex = thresholds.indexOf(showThresholds[0]);
            }

            // Progress bar logic
            const visualProgressTotal = Math.max(cart_total, original_cart_total);
            const maxThreshold = parseFloat(window.promotionalProgressbar.at(-1).threshold);
            const totalBars = _.selector.bars.length;
            const segment = maxThreshold / totalBars;

            _.selector.bars.forEach((bar, index) => {
              // Activate bars up to the last active threshold or up to the next threshold to unlock

              // For debugging
              // console.log( lastActiveIndex, nextShowIndex, visualProgressTotal , (index + 1) * segment);
              const shouldActivate =
                index <= lastActiveIndex ||
                (nextShowIndex !== -1 && index < nextShowIndex && visualProgressTotal >= (index + 1) * segment);

              if (shouldActivate) {
                bar.classList.add("active");
              } else {
                bar.classList.remove("active");
              }
            });
          }
          if (_.state.closestLowerArray.length >= window.promotionalProgressbar.length) {
            if (progressHeadingRoot) progressHeadingRoot.classList.remove("empty-title");
            if (headingEl) headingEl.innerHTML = `${headingEl.dataset.finalHeading || ""}`;
          }
        }

        if (cart_total == 0 && original_cart_total == 0) {
          _.state.giftVariantBlocked = [];
          const headingElZero = _.selector.heading;
          const progressHeadingRootZero = headingElZero && headingElZero.closest(".progress-heading");
          if (progressHeadingRootZero) progressHeadingRootZero.classList.remove("empty-title");
          if (headingElZero && _.selector.main) headingElZero.textContent = _.selector.main.dataset.cartZeroText || "";
          _.selector.bars.forEach((bar) => {
            bar.classList.remove("active");
          });
          const activeThresholdBars = document.querySelectorAll(
            ".promotional-progress > .progress > .bars-threshold > .threshold.show",
          );
          activeThresholdBars.forEach((bar) => {
            bar.classList.remove("active");
          });
        }
      })
      .catch((error) => {
        console.error("Error in recalculate:", error);
      })
      .finally(() => {
        _.state.isRecalculating = false;
        window.theme?.cartDrawerBusy?.end?.(lastCartState);

        if (_.state.recalculateTimeout) {
          clearTimeout(_.state.recalculateTimeout);
          _.state.recalculateTimeout = null;
          setTimeout(function () {
            _.recalculate();
          }, 50);
        }
      });
  };
  PromotionalProgressbar.prototype.adjustFreeGiftQuantity = async function (key, targetQuantity) {
    var _ = this;
    if (!_.state.isRecalculating) {
      window.theme?.cartDrawerBusy?.begin?.();
    }
    var lastCart = null;
    const formData = {
      id: key,
      quantity: targetQuantity,
      sections: "cart-drawer",
    };
    await fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function () {
            throw new Error("cart/change HTTP " + response.status);
          });
        }
        return response.json();
      })
      .then((data) => {
        lastCart = data;
        if (data.sections && data.sections["cart-drawer"]) {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data.sections["cart-drawer"], "text/html");
          const specificContainer = htmlDoc.getElementById("CartDrawer-Form");
          if (specificContainer) {
            _.selector.formCartDrawer.innerHTML = specificContainer.innerHTML;
          } else {
            console.error("Specific container not found");
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        if (!_.state.isRecalculating) {
          window.theme?.cartDrawerBusy?.end?.(lastCart);
          _.scheduleRecalculate(150);
        }
      });
  };
  PromotionalProgressbar.prototype.checkfreegift = async function (
    variants,
    mode,
    productId,
    productName,
    variantImage,
    productHandle,
    optionTriggerFound,
    automaticallyAdded,
    cartSnapshot,
  ) {
    var _ = this;

    if (mode === "add" && (!Array.isArray(variants) || variants.length === 0)) {
      return;
    }

    var productIdKey = String(productId);

    // Check if this free gift product is already being processed
    if (_.state.processingFreeGifts.includes(productIdKey)) {
      return; // Skip if already processing
    }

    // Add to processing state
    _.state.processingFreeGifts.push(productIdKey);

    var runWithCart = async function (data) {
          if (data.item_count > 0) {
            const foundFreeGift = data.items.find((item) => cartItemMatchesProductId(item, productId));
            if (foundFreeGift) {
              // If free gift exists, ensure quantity is always 1
              if (parseInt(foundFreeGift.quantity) > 1) {
                await _.adjustFreeGiftQuantity(foundFreeGift.key, 1);
              }
              // If mode is 'remove', remove it
              if (mode === "remove") {
                await _.removefreegift(foundFreeGift.key);
              }
            } else if (!foundFreeGift && mode === "add") {
              var firstVariantId = variants[0] && variants[0].id;
              if (firstVariantId != null && _.state.giftVariantBlocked.indexOf(String(firstVariantId)) !== -1) {
                return;
              }
              // Only add if it doesn't exist
              if (promotionalBool(automaticallyAdded) && !_.state.deletedFreeGift.includes(String(variants[0].id))) {
                await _.addfreegift(variants[0].id);
              } else {
                await _.initiatefreegift(
                  productId,
                  variants,
                  productName,
                  variantImage,
                  productHandle,
                  optionTriggerFound,
                  automaticallyAdded,
                );
              }
            }
          }
    };

    try {
      if (cartSnapshot) {
        await runWithCart(cartSnapshot);
      } else {
        await fetch(window.Shopify.routes.root + "cart.js", {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        })
          .then(function (response) {
            if (!response.ok) {
              return response.text().then(function () {
                throw new Error("cart.js HTTP " + response.status);
              });
            }
            return response.json();
          })
          .then(runWithCart)
          .catch(function (error) {
            console.error(error);
          });
      }
    } finally {
      _.state.processingFreeGifts = _.state.processingFreeGifts.filter(function (id) {
        return id !== productIdKey;
      });
    }
  };
  PromotionalProgressbar.prototype.initiatefreegift = async function (
    id,
    variants,
    productName,
    variantImage,
    productHandle,
    optionTriggerFound,
    automaticallyAdded,
  ) {
    var _ = this;
    const freeGiftOptionsEnabled = promotionalBool(optionTriggerFound);
    const freeGiftAutomaticallyAdded = promotionalBool(automaticallyAdded);
    const existingFreeAddItem = document.getElementById(`free-gift-unlocked-${id}`);
    existingFreeAddItem && existingFreeAddItem.remove();
    const freeGiftUnlockedInnerHtml = `<div class="image">
                    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 821.86 701.35" width="30px" height="30px" class="unlocked">
                        <defs>
                        <style>
                            .cls-1 {
                            fill: #67645E;
                            stroke-width: 0px;
                            }
                        </style>
                        </defs>
                        <rect class="cls-1" x="37.37" y="481.31" width="142.96" height="36.53" transform="translate(-235.2 121.35) rotate(-30)"></rect>
                        <path class="cls-1" d="M553.1,223.74v-23.07c0-88.72-72.18-160.9-160.9-160.9s-160.9,72.18-160.9,160.9v87.92h36.53v-87.92c0-68.58,55.8-124.38,124.38-124.38s124.38,55.79,124.38,124.38v44.15l-6.64,3.84-215.43,124.38-31.63,18.26-38.67,22.32,166.12,287.72,356.03-205.55-166.12-287.72-27.13,15.66ZM521.47,553.93l-43.09-74.63c-25.15,5.57-52.06-5.41-65.63-28.9-16.75-29.01-6.81-66.1,22.2-82.84,29.01-16.75,66.1-6.81,82.84,22.2,13.56,23.49,9.62,52.29-7.78,71.28l43.09,74.63-31.63,18.26Z"></path>
                        <rect class="cls-1" x="573.4" y="52.77" width="142.96" height="36.53" transform="translate(260.92 593.99) rotate(-60)"></rect>
                        <rect class="cls-1" y="381.94" width="142.95" height="36.53"></rect>
                        <rect class="cls-1" x="104.9" y="563.08" width="142.96" height="36.53" transform="translate(-415.27 443.42) rotate(-60)"></rect>
                        <rect class="cls-1" x="678.9" y="235.48" width="142.95" height="36.53"></rect>
                        <rect class="cls-1" x="642.18" y="134.47" width="142.96" height="36.53" transform="translate(19.24 377.29) rotate(-30)"></rect>
                    </svg>
                        <img src="${variantImage}" width="50" height="50" alt="${productName}" title="${productName}" loading="eager">
                    </div>
                    <div class="details">
                    <span>You've unlocked a <strong>${productName}</strong></span>
                    <div class="${freeGiftOptionsEnabled ? "variant-options-container no-select-options" : "variant-options-container"}${freeGiftAutomaticallyAdded ? " automatic-added" : ""}">
                        <select name="variant_options" title="Choose option" id="variant-options-${id}" class="variant-options${freeGiftOptionsEnabled ? " freegift-quick-view-modal-btn" : ""}" data-product-url="/products/${productHandle}">
                            <option disabled selected ${freeGiftAutomaticallyAdded && "value=" + variants[0].id}>CHOOSE OPTION</option>
                        </select>
                        <button type="button" class="freegift-add-to-cart" ${!freeGiftAutomaticallyAdded && "disabled"} ${freeGiftAutomaticallyAdded && 'data-automatic="true"'}>ADD TO CART</button>
                    </div>
                    </div>`;
    let freeGiftAddItem = document.createElement("div");
    freeGiftAddItem.id = `free-gift-unlocked-${id}`;
    freeGiftAddItem.classList.add("free-gift-unlocked");
    freeGiftAddItem.innerHTML = freeGiftUnlockedInnerHtml;
    const freeGiftUnlockedContainer = document.getElementById("free-gift-unlocked");
    if (!freeGiftUnlockedContainer) return;
    freeGiftUnlockedContainer.append(freeGiftAddItem);
    freeGiftUnlockedContainer.classList.add("active");
    const variantOptionsSelect = document.getElementById(`variant-options-${id}`);
    if (variantOptionsSelect && !freeGiftOptionsEnabled && !freeGiftAutomaticallyAdded) {
      Array.from(variants).map((variant) => {
        let option = document.createElement("option");
        option.value = variant.id;
        option.text = variant.title;
        variantOptionsSelect.append(option);
      });
    }
  };
  PromotionalProgressbar.prototype.removefreegift = async function (key) {
    var _ = this;
    if (!_.state.isRecalculating) {
      window.theme?.cartDrawerBusy?.begin?.();
    }
    var lastCart = null;
    const formData = {
      id: key,
      quantity: 0,
      sections: "cart-drawer",
    };
    await fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(function (response) {
        if (!response.ok) {
          return response.text().then(function () {
            throw new Error("cart/change HTTP " + response.status);
          });
        }
        return response.json();
      })
      .then((data) => {
        lastCart = data;
        if (data.sections && data.sections["cart-drawer"]) {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data.sections["cart-drawer"], "text/html");
          const specificContainer = htmlDoc.getElementById("CartDrawer-Form");
          if (specificContainer) {
            _.selector.formCartDrawer.innerHTML = specificContainer.innerHTML;
          } else {
            console.error("Specific container not found");
          }
        }

        if (data.items && data.items.length > 0) {
          const productId = data.items[0].product_id;
          if ((localStorage.getItem("ebsRecentlyFreeGiftProductIds") || []).includes(productId)) {
            const existing = localStorage.getItem("ebsRecentlyFreeGiftProductIds");
            let ids = [];
            try {
              ids = existing ? JSON.parse(existing) : [];
            } catch (e) {
              ids = [];
            }
            ids = Array.isArray(ids) ? ids.filter((id) => id !== productId) : [];
            localStorage.setItem("ebsRecentlyFreeGiftProductIds", JSON.stringify(ids));
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        if (!_.state.isRecalculating) {
          window.theme?.cartDrawerBusy?.end?.(lastCart);
          _.scheduleRecalculate(150);
        }
      });
  };
  PromotionalProgressbar.prototype.addfreegift = async function (id) {
    var _ = this;
    if (!_.state.isRecalculating) {
      window.theme?.cartDrawerBusy?.begin?.();
    }
    var lastCart = null;
    const formData = {
      items: [
        {
          id: id,
          quantity: 1,
        },
      ],
      sections: "cart-drawer",
    };
    var addSucceeded = false;
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(async function (response) {
        var data = {};
        try {
          data = await response.json();
        } catch (e) {
          data = {};
        }
        if (!response.ok) {
          if (response.status === 422 && id != null) {
            var sid = String(id);
            if (_.state.giftVariantBlocked.indexOf(sid) === -1) {
              _.state.giftVariantBlocked.push(sid);
            }
          }
          console.warn("PromotionalProgressbar: cart/add.js failed", response.status, data);
          return;
        }
        addSucceeded = true;
        lastCart = data;
        if (data.sections && data.sections["cart-drawer"]) {
          const parser = new DOMParser();
          const htmlDoc = parser.parseFromString(data.sections["cart-drawer"], "text/html");
          const specificContainer = htmlDoc.getElementById("CartDrawer-Form");
          // const cartCount = htmlDoc.getElementById('cart-count-bubble');
          // if(cartCount) {
          //     _.selector.cartCountBubble.textContent = cartCount.textContent;
          // }
          if (specificContainer) {
            _.selector.formCartDrawer.innerHTML = specificContainer.innerHTML;
          } else {
            console.error("Specific container not found");
          }
        }

        // Add the product id to the recently free gift product ids if it's not already in the array
        if (data.items && data.items.length > 0) {
          const productId = data.items[0].product_id;
          if (!(localStorage.getItem("ebsRecentlyFreeGiftProductIds") || []).includes(productId)) {
            // Read the current list from localStorage, or initialize with an empty array if not set
            let ids = [];
            try {
              ids = JSON.parse(localStorage.getItem("ebsRecentlyFreeGiftProductIds")) || [];
            } catch (e) {
              ids = [];
            }
            if (!ids.includes(productId)) {
              ids.push(productId);
              localStorage.setItem("ebsRecentlyFreeGiftProductIds", JSON.stringify(ids));
            }
          }
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        if (!_.state.isRecalculating) {
          window.theme?.cartDrawerBusy?.end?.(lastCart);
          if (addSucceeded) {
            _.scheduleRecalculate(150);
          }
        }
      });
  };
  PromotionalProgressbar.prototype.addBackRemovedItem = async function (variantId) {
    var _ = this;
    if (!_.state.isRecalculating) {
      window.theme?.cartDrawerBusy?.begin?.();
    }
    var lastCart = null;
    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
      sections: "cart-drawer",
    };
    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(async function (response) {
        var data = {};
        try {
          data = await response.json();
        } catch (e) {
          data = {};
        }
        if (!response.ok) {
          if (response.status === 422 && variantId != null) {
            var vid = String(variantId);
            if (_.state.giftVariantBlocked.indexOf(vid) === -1) {
              _.state.giftVariantBlocked.push(vid);
            }
          }
          console.warn("PromotionalProgressbar: cart/add.js (addBack)", response.status, data);
          return;
        }
        try {
          lastCart = data;
          if (data.sections && data.sections["cart-drawer"]) {
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(data.sections["cart-drawer"], "text/html");
            const specificContainer = htmlDoc.getElementById("CartDrawer-Form");
            if (specificContainer) {
              _.selector.formCartDrawer.innerHTML = specificContainer.innerHTML;
            }
          }
        } catch (e) {}
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        if (!_.state.isRecalculating) {
          window.theme?.cartDrawerBusy?.end?.(lastCart);
          _.scheduleRecalculate(150);
        }
      });
  };
  theme.PromotionalProgressbar = new PromotionalProgressbar();
};
theme.PromotionalProgressbar();
